import useForm from "antd/es/form/hooks/useForm";
import { Button, Form, Modal, Input } from "@renderbus/ui";
import styled, { createGlobalStyle } from "styled-components";
import { getTranslateNsT } from "@/utils/getTranslateNsT";
import { useEffect, useState } from "react";
import { ISubAccountData } from "@/store/SubAccountStore";
import { useSubAccountStore } from "@/store/SubAccountStore";
import { useValidator } from "@/pages/child-customer/view/child-manage/hooks/useValidator";
import request from "project-config/services/request/request";
import { RadioChangeEvent, message } from "antd";
import { TextButton } from "@/pages/child-customer/atom";

import { Radio } from "antd";

export interface IEditChildFormProps {
  email: string;
  phone: string;
  subPassword: string;
  subUserName: string;
}

export function EditChildButton({ onClick }: { onClick: () => void }) {
  const t = getTranslateNsT("center");
  return (
    <div>
      <TextButton type="text" onClick={onClick}>
        {t("user_com_childManage_del_render_btn_edit")}
      </TextButton>
    </div>
  );
}

export function EditChildModal({
  open,
  setOpen,
  ...row
}: ISubAccountData & {
  open: boolean;
  setOpen: (open: boolean) => void;
}) {
  const t = getTranslateNsT("center");
  const [confirmBtnDisable, setConfirmBtnDisable] = useState(false);
  const { phone, email, id, subUserName } = row;
  const { fetchSubAccountList } = useSubAccountStore();
  const {
    passwordValidator,
    phoneValidator,
    emailValidator,
    subUserNameValidator,
  } = useValidator();
  const [form] = useForm<IEditChildFormProps>();
  const [useNewPassword, SetUseNewPassword] = useState(false);
  function handleCancel() {
    setOpen(false);
    form.resetFields();
  }
  async function handleEdit() {
    form
      .validateFields()
      .then(async () => {
        const formValues = form.getFieldsValue();
        const param = {
          id,
          email: formValues.email,
          phone: formValues.phone,
          subPassword: formValues.subPassword,
          subUserName: formValues.subUserName,
        };
        param.email === email && Reflect.deleteProperty(param, "email");
        param.phone === phone && Reflect.deleteProperty(param, "phone");
        param.subUserName === subUserName &&
          Reflect.deleteProperty(param, "subUserName");
        const res = await request.post(
          "/api/rendering/user/modifySubUser",
          param
        );
        if (res.code === 200) {
          fetchSubAccountList();
          setOpen(false);
          form.resetFields();
          message.success(t("user_com_modify_label_success_msg"));
        } else if (res.code === 723) {
          form.setFields([
            {
              name: "subPassword",
              value: param.subPassword,
              errors: [t("user_com_childManage_del_render_form_same_password")],
            },
          ]);
        } else {
          setOpen(false);
          form.resetFields();
          message.error(t("user_com_modify_label_error_msg"));
        }
      })
      .catch(console.log);
  }
  function handleValuesChange(changedValues: any, allValues: any) {
    if (
      allValues["phone"] === phone &&
      allValues["email"] === email &&
      allValues["subUserName"] === subUserName &&
      !allValues["subPassword"]
    ) {
      setConfirmBtnDisable(true);
    } else {
      setConfirmBtnDisable(false);
    }
  }
  function radioChange(e: RadioChangeEvent) {
    SetUseNewPassword(e.target.value);
    form.setFieldsValue({
      subPassword: undefined,
    });
    const values = form.getFieldValue("subPassword");
    if (values === ("" || undefined)) {
      setConfirmBtnDisable(true);
    }
  }
  useEffect(() => {
    if (open) {
      setConfirmBtnDisable(true);
      SetUseNewPassword(false);
      form.setFieldsValue({
        phone,
        email,
        subUserName,
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [open]);
  return (
    <>
      <Modal
        open={open}
        className="renderbus-ui--modal edit-child"
        title={t("user_com_childManage_del_title_edit")}
        children={
          <FormBox>
            <Form
              size={"large"}
              colon={false}
              requiredMark={false}
              form={form}
              labelCol={{ span: 6 }}
              labelAlign="left"
              onValuesChange={handleValuesChange}
            >
              <Form.Item
                label={t("user_com_modify_label_subuser")}
                validateTrigger="onBlur"
                name="subUserName"
                key="subUserName"
                rules={[
                  {
                    validator: (...arg) =>
                      subUserNameValidator(
                        arg,
                        false,
                        form.getFieldsValue().subUserName !== subUserName
                      ),
                    validateTrigger: "onBlur",
                  },
                ]}
              >
                <Input
                  className="edit-child-input"
                  placeholder={t("user_com_childManage_sub_place")}
                  autoComplete="new-password"
                />
              </Form.Item>
              <Form.Item
                key="phone"
                name="phone"
                label={t("user_com_modify_label_tel")}
                validateTrigger="onBlur"
                rules={[
                  {
                    validator: (...arg) =>
                      phoneValidator(arg, true, true, phone),
                    validateTrigger: "onBlur",
                  },
                ]}
              >
                <Input className="edit-child-input" autoComplete={"off"} />
              </Form.Item>
              <Form.Item
                key="email"
                name="email"
                label={t("user_com_modify_label_email")}
                validateTrigger="onBlur"
                rules={[
                  {
                    validator: (...arg) =>
                      emailValidator(arg, true, true, email),
                    validateTrigger: "onBlur",
                  },
                ]}
              >
                <Input className="edit-child-input" autoComplete={"off"} />
              </Form.Item>
              <div className="wudi">
                <div>{t("user_com_modify_label_psw")}</div>
                <div>
                  <Radio.Group onChange={radioChange} value={useNewPassword}>
                    <Radio value={false}>
                      {t("user_com_modify_label_keep_password")}
                    </Radio>
                    <Radio value={true}>
                      {t("user_com_modify_label_new_password")}
                    </Radio>
                  </Radio.Group>
                </div>
              </div>
              <Form.Item
                key="subPassword"
                name="subPassword"
                required
                rules={[
                  {
                    validator: (...arg) => passwordValidator(arg, true),
                    validateTrigger: "onBlur",
                  },
                ]}
              >
                <Input
                  className="edit-child-input"
                  type="password"
                  disabled={!useNewPassword}
                  placeholder={
                    useNewPassword
                      ? t("user_com_modify_label_enter_password")
                      : "********"
                  }
                  autoComplete={"off"}
                />
              </Form.Item>
            </Form>
          </FormBox>
        }
        footer={[
          <Button key="back" onClick={handleCancel}>
            {t("user_com_childManage_render_btn_cancel")}
          </Button>,
          <Button
            key="submit"
            type="primary"
            disabled={confirmBtnDisable}
            onClick={handleEdit}
          >
            {t("user_com_childManage_render_btn_comfirm")}
          </Button>,
        ]}
        onCancel={handleCancel}
      />
      <EditChildStyle />
    </>
  );
}

const EditChildStyle = createGlobalStyle`
  .edit-child-input {
    background: #2C2C31 !important;
  }
  .edit-child .ant-modal-body {
    padding: 24px 24px 22px !important;
  }
`;

const FormBox = styled.div`
  .ant-form-item-row {
    display: block;
  }
  .ant-form {
    padding: 0px 40px;
    .ant-form-item-label {
      text-align: left;
      max-width: 35%;
    }
  }
  .wudi {
    width: 100%;
    height: 25px;
    display: flex;
    justify-content: space-between;
  }

  .form_item {
    .ant-form-item-row {
      display: flex;
      justify-content: flex-start;
    }
  }
  .ant-radio-wrapper .ant-radio-checked .ant-radio-inner {
    background-color: var(--main-color);
    border-color: var(--main-color);
  }
  .ant-radio-wrapper:hover .ant-radio-inner {
    border-color: var(--main-color);
  }
`;
